(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };

  /* ---------- mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-burger]');
    if (burger) {
      var d = $('[data-drawer]');
      if (d) { d.classList.toggle('is-open'); burger.setAttribute('aria-expanded', d.classList.contains('is-open')); }
    }
  });

  /* ---------- cart drawer ---------- */
  function drawer() { return $('[data-cart-drawer]'); }
  function veil() { return $('[data-cart-veil]'); }

  function openCart(added) {
    var d = drawer(); if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    veil().hidden = false;
    document.body.style.overflow = 'hidden';
    var msg = $('[data-cart-added]');
    if (msg) {
      msg.hidden = !added;
      if (added) { clearTimeout(window.__addT); window.__addT = setTimeout(function () { msg.hidden = true; }, 2600); }
    }
  }
  function closeCart() {
    var d = drawer(); if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    veil().hidden = true;
    document.body.style.overflow = '';
  }

  function refresh(added) {
    return fetch(window.Shopify.routes.root + '?section_id=cart-items')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-body]') || doc.body.firstElementChild;
        var body = $('[data-cart-body]');
        if (body && fresh) { body.innerHTML = fresh.innerHTML; }
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        var lbl = $('[data-cart-count-label]');
        if (lbl) { lbl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items'); }
        openCart(added);
      })
      .catch(function () { window.location.href = window.Shopify.routes.root + 'cart'; });
  }

  function addToCart(id, qty) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function () { return refresh(true); });
  }

  function changeQty(key, qty) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Number(qty) })
    }).then(function () { return refresh(false); });
  }

  /* ---------- quick add ----------------------------------------------
     Builds ONE PILL ROW PER PRODUCT OPTION - so a bow with 4 sizes and
     3 colours shows 4 pills then 3 pills, not 12 combination pills.
     The customer picks one from each row, then presses Add to bag.
     ------------------------------------------------------------------ */

  var qaState = null;   /* { data, chosen[] } for the open modal */

  function qaVariant() {
    if (!qaState) return null;
    var data = qaState.data, chosen = qaState.chosen;
    for (var i = 0; i < data.options.length; i++) {
      if (!chosen[i]) return null;               /* not finished choosing */
    }
    return data.variants.filter(function (v) {
      return v.options.join('\u0000') === chosen.join('\u0000');
    })[0] || null;
  }

  /* is there any available variant with `val` in group `gi`,
     given whatever else is currently chosen? */
  function qaValuePossible(gi, val) {
    var data = qaState.data, chosen = qaState.chosen;
    return data.variants.some(function (v) {
      if (!v.available) return false;
      if (v.options[gi] !== val) return false;
      for (var i = 0; i < chosen.length; i++) {
        if (i !== gi && chosen[i] && v.options[i] !== chosen[i]) return false;
      }
      return true;
    });
  }

  function qaSync() {
    var wrap = $('[data-qa-opts]');
    var addBtn = $('[data-qa-add]');
    var errEl = $('[data-qa-error]');
    var priceEl = $('[data-qa-price]');
    if (!wrap || !addBtn) return;

    /* reflect selection + grey out combinations that cannot be bought */
    wrap.querySelectorAll('[data-qa-val]').forEach(function (b) {
      var gi = Number(b.getAttribute('data-qa-group'));
      var val = b.getAttribute('data-qa-val');
      b.setAttribute('aria-pressed', qaState.chosen[gi] === val ? 'true' : 'false');
      b.disabled = !qaValuePossible(gi, val);
    });

    var v = qaVariant();
    var done = qaState.chosen.filter(Boolean).length === qaState.data.options.length;

    if (!done) {
      addBtn.disabled = true;
      addBtn.textContent = 'Select options';
      addBtn.removeAttribute('data-variant-id');
      errEl.hidden = true;
      return;
    }

    if (!v) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      addBtn.removeAttribute('data-variant-id');
      errEl.hidden = false;
      return;
    }

    errEl.hidden = true;
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
    addBtn.setAttribute('data-variant-id', v.id);
    if (priceEl && qaState.data.show_prices && v.price_formatted) {
      priceEl.textContent = v.price_formatted;
    }
  }

  function openQA(card) {
    var data = JSON.parse(card.querySelector('[data-qa-data]').textContent);
    var qa = $('[data-qa]');
    if (!qa) return;

    qaState = { data: data, chosen: [] };

    $('[data-qa-title]').textContent = data.title;
    $('[data-qa-price]').textContent = data.price;
    $('[data-qa-img]').innerHTML = data.image ? '<img src="' + data.image + '" alt="">' : '';

    var link = $('[data-qa-link]');
    if (link) { link.href = data.url || '#'; }

    var wrap = $('[data-qa-opts]');
    wrap.innerHTML = '';

    (data.options || []).forEach(function (opt, gi) {
      var group = document.createElement('div');
      group.className = 'qa__group';

      var label = document.createElement('p');
      label.className = 'qa__grouplabel';
      label.textContent = opt.name;
      group.appendChild(label);

      var row = document.createElement('div');
      row.className = 'qa__pills';

      opt.values.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = val;
        b.setAttribute('data-qa-val', val);
        b.setAttribute('data-qa-group', String(gi));
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          /* tapping the chosen pill again clears it */
          qaState.chosen[gi] = (qaState.chosen[gi] === val) ? '' : val;
          qaSync();
        });
        row.appendChild(b);
      });

      group.appendChild(row);
      wrap.appendChild(group);
    });

    /* a group with only one value needs no choosing */
    (data.options || []).forEach(function (opt, gi) {
      qaState.chosen[gi] = opt.values.length === 1 ? opt.values[0] : '';
    });

    qaSync();

    qa.hidden = false;
    $('[data-qa-veil]').hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeQA() {
    var qa = $('[data-qa]'); if (!qa) return;
    qa.hidden = true;
    $('[data-qa-veil]').hidden = true;
    document.body.style.overflow = '';
    qaState = null;
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(false); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-veil]')) { closeCart(); return; }
    if (e.target.closest('[data-qa-close]') || e.target.closest('[data-qa-veil]')) { closeQA(); return; }

    var qaBtn = e.target.closest('[data-qa-open]');
    if (qaBtn) { e.preventDefault(); openQA(qaBtn.closest('.pcard-wrap')); return; }

    var qaAdd = e.target.closest('[data-qa-add]');
    if (qaAdd) {
      e.preventDefault();
      if (qaAdd.disabled) return;
      var vid = qaAdd.getAttribute('data-variant-id');
      if (!vid) return;
      qaAdd.disabled = true;
      qaAdd.textContent = '…';
      addToCart(vid, 1).then(closeQA);
      return;
    }

    var qty = e.target.closest('[data-qty]');
    if (qty) { e.preventDefault(); changeQty(qty.dataset.qty, qty.dataset.to); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeQA(); }
  });

  /* save cart note on blur */
  document.addEventListener('blur', function (e) {
    if (e.target.matches && e.target.matches('[data-cart-note]')) {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: e.target.value })
      });
    }
  }, true);

  /* PDP add to cart -> drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-variant-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var q = form.querySelector('[name="quantity"]');
    addToCart(id, q ? q.value : 1);
  });

  /* PDP variant switching */
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      var opts = Array.prototype.slice.call(form.querySelectorAll('[data-opt]:checked')).map(function (i) { return i.value; });
      var data = JSON.parse(form.querySelector('[data-variants]').textContent);
      var match = data.filter(function (v) { return v.options.join(' / ') === opts.join(' / '); })[0];
      var idInput = form.querySelector('[name="id"]');
      var btn = form.querySelector('[data-add]');
      /* the price sits OUTSIDE the form in the product template, so this
         has to search the document - form.querySelector always missed it,
         which is why the displayed price never changed. */
      var price = document.querySelector('[data-price]');
      if (match) {
        idInput.value = match.id;
        if (price && match.price_formatted) { price.textContent = match.price_formatted; }
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
    });
  });

  /* ---------- enquiry pills: switch forms in place ---------- */
  function eqSet(root, tab) {
    root.querySelectorAll('[data-eq-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', b.getAttribute('data-eq-tab') === tab ? 'true' : 'false');
    });
    ['pane', 'form', 'kicker'].forEach(function (k) {
      root.querySelectorAll('[data-eq-' + k + ']').forEach(function (el) {
        el.hidden = el.getAttribute('data-eq-' + k) !== tab;
      });
    });
  }
  function eqInit() {
    document.querySelectorAll('[data-enquiry]').forEach(function (root) {
      var d = root.querySelector('[data-eq-default]');
      var want = (location.hash === '#book-sitting' || /dog-sitting/.test(location.pathname)) ? 'sitting'
        : (d && d.getAttribute('data-eq-default')) || 'wedding';
      eqSet(root, want);
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-eq-tab]');
    if (!t) return;
    e.preventDefault();
    eqSet(t.closest('[data-enquiry]'), t.getAttribute('data-eq-tab'));
  });
  document.addEventListener('change', function (e) {
    var r = e.target.closest('[data-transport]');
    if (!r) return;
    var form = r.closest('form');
    if (!form) return;
    var show = r.getAttribute('data-transport') === 'yes';
    form.querySelectorAll('[data-transport-fields]').forEach(function (el) { el.hidden = !show; });
  });
  document.addEventListener('change', function (e) {
    var r = e.target.closest('[data-overnight]');
    if (!r) return;
    var form = r.closest('form');
    if (!form) return;
    var show = r.getAttribute('data-overnight') === 'yes';
    form.querySelectorAll('[data-overnight-note]').forEach(function (el) { el.hidden = !show; });
  });
  eqInit();
  document.addEventListener('shopify:section:load', eqInit);

})();


/* dog sitting booking form: customer type + per-dog detail slots */
(function () {
  function dogMarkup(prefix, n, total) {
    var label = total > 1 ? 'Dog ' + n : 'Dog details';
    return '<p class="eyebrow" style="margin:18px 0 14px">' + label + '</p>' +
      '<div class="dog-grid">' +
      '<div class="field"><label>Dog name *</label><input class="input" type="text" required name="contact[Dog ' + n + ' name]"></div>' +
      '<div class="field"><label>Breed *</label><input class="input" type="text" required name="contact[Dog ' + n + ' breed]"></div>' +
      '<div class="field"><label>Age</label><input class="input" type="text" name="contact[Dog ' + n + ' age]"></div>' +
      '<div class="field"><label>Size</label><select class="input" name="contact[Dog ' + n + ' size]"><option>Small (under 10kg)</option><option>Medium (10–25kg)</option><option>Large (25–40kg)</option><option>Extra large (40kg+)</option></select></div>' +
      '<div class="field"><label>Gender</label><select class="input" name="contact[Dog ' + n + ' gender]"><option>Female</option><option>Male</option></select></div>' +
      '</div>';
  }
  function renderDogs(form) {
    var slots = form.querySelector('[data-dog-slots]');
    var count = form.querySelector('[data-dog-count]');
    if (!slots || !count) return;
    var total = parseInt(count.value, 10) || 1, html = '';
    for (var i = 1; i <= total; i++) html += dogMarkup(slots.getAttribute('data-prefix'), i, total);
    slots.innerHTML = html;
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-dog-count]')) renderDogs(e.target.closest('form'));
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cust-tab]');
    if (!btn) return;
    var scope = btn.closest('[data-eq-form="sitting"]');
    var want = btn.getAttribute('data-cust-tab');
    scope.querySelectorAll('[data-cust-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', b.getAttribute('data-cust-tab') === want ? 'true' : 'false');
    });
    scope.querySelectorAll('[data-cust-pane]').forEach(function (p) {
      p.hidden = p.getAttribute('data-cust-pane') !== want;
    });
  });
  document.querySelectorAll('[data-dog-slots]').forEach(function (s) { renderDogs(s.closest('form')); });
})();